import { useState } from 'react'
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { Link } from 'react-router-dom'
import { Input } from '../../components/input'
import { InputWrapper } from '../../components/input/input.style'
import { AuthFormWrapper } from '../../container/authFormwarapper'
import { Heading, FormContainer, ButtonContainer, InfoBlock, InfoBlockText } from '../../styles/auth'
import { Button } from '../../components/button'

//Forgot password schema
const schema = yup.object().shape({
    email: yup.string().email().required("Email field is a required field"),

});

const ForgotPassword = () => {
    const [isLoading, setIsLoading] = useState(false);
    const {
        handleSubmit,
        register,
        formState: { errors },
        watch,
    } = useForm({ resolver: yupResolver(schema), mode: "onChange" });
    // const formData = JSON.stringify(watch());

    const onSubmit = values => {
        console.log(values)
    }
    return (
        <AuthFormWrapper>
            <FormContainer>
                <Link to="/">Go home</Link>
                <Heading>Forgot Password</Heading>
                <InfoBlock>
                    <img src="/assets/images/checkIcon.webp" alt="check icon" />
                    <InfoBlockText>An email with password reset instructions has been sent to your email address, if it exists on our system.</InfoBlockText>
                </InfoBlock>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <InputWrapper>
                        <Input
                            id="emailAddress"
                            label="email address"
                            type="email"
                            placeholder="Email address"
                            fullWidth
                            {...register("email")}
                            error={errors.email?.message}
                        />
                    </InputWrapper>
                    <ButtonContainer>
                        <Button
                            type="submit"
                            disabled={
                                Object.keys(errors).length > 0 ||
                                Object.values(watch()).length < 1 ||
                                isLoading
                            }
                            variant="primary"
                            isLoading={isLoading}
                            responsive
                        >
                            recover password
                        </Button>
                    </ButtonContainer>

                </form>
            </FormContainer>
        </AuthFormWrapper>
    )
}

export default ForgotPassword
